import { Api } from '../Common/rest-api/api-exports';
import * as _ from 'ramda';

export const getCompaniesList = (data = {}) => {
    return Api.Companies.list(data)
        .then(res => {
            return res.body;
        })
        .catch(error => error);
};

export const getCompaniesListWhitoutOnwers = () => {
    return Api.Companies.whitoutOwner()
        .then(res => {
            const companies = res.body;
            const companiesCount = res.body.length;

            return _.mergeAll([{ companies: companies }, { count: companiesCount }]);
        })
        .catch(err => err);
};

// Return list of companies without owners and company of current user if he has one.
export const getCompaniesListForOwner = id => {
    return Api.Users.single(id)
        .then(res => {
            let companyOfUser;
            res.body.company
                ? (companyOfUser = {
                      id: res.body.company.id,
                      name: res.body.company.name
                  })
                : (companyOfUser = 'no company');

            return Api.Companies.whitoutOwner()
                .then(res => {
                    let companiesWithoutOwnerAndOwnerCompany;

                    companyOfUser === 'no company'
                        ? (companiesWithoutOwnerAndOwnerCompany = res.body)
                        : (companiesWithoutOwnerAndOwnerCompany = _.append(companyOfUser, res.body));

                    const companiesWithoutOwnerAndOwnerCompanyCount = companiesWithoutOwnerAndOwnerCompany.length;

                    return _.mergeAll([
                        { companies: companiesWithoutOwnerAndOwnerCompany },
                        { count: companiesWithoutOwnerAndOwnerCompanyCount }
                    ]);
                })
                .catch(() => []);
        })
        .catch(() => []);
};

export const getCompaniesReducedList = () => {
    return Api.Companies.listReduced()
        .then(res => {
            const companiesList = res.body;
            const companiesCount = res.body.length;
            return _.mergeAll([{ companies: companiesList }, { count: companiesCount }]);
        })
        .catch(error => error);
};

export const getPharmaciesForSingleCompany = id => {
    return Api.Companies.pharmacies(id)
        .then(res => {
            const phrmaciesList = res.body;
            const pharmaciesCount = res.body.length;
            return _.mergeAll([{ pharmacies: phrmaciesList }, { count: pharmaciesCount }]);
        })
        .catch(err => err);
};

export const getSingleCompany = id => {
    return Api.Companies.single(id)
        .then(res => res.body)
        .catch(err => err);
};

export const getSingleCompanyDetails = id => {
    return Api.Companies.single(id)
        .then(res => res.body)
        .catch(err => err);
};

export const createCompany = details => {
    return Api.Companies.add({
        name: details.companyName,
        address: details.companyAddress,
        phone: details.companyPhone
    });
};

export const editCompany = (id, details) => {
    return Api.Companies.edit(id, {
        name: details.name,
        address: details.address,
        phone: details.phone,
        owner: details.companyOwnerId
    });
};

export const uploadPrices = (details, id) => {
    return Api.Companies.uploadPrices(details, id);
};


// WEBPACK FOOTER //
// ./src/customModules/Companies/epics-companies.js